module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "id": "cont",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "h2f"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_v",
      "title": "v"
    }
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf0",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044075_Acknowledgments"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf0",
    attrs: {
      "id": "name"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044075_Naming"
    }
  }, [_c('i', [_vm._v("Note on Spelling and Naming")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "int"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044075_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044075_Chapter_1"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "spacect"
  }, [_vm._v("The Land without Music (1899–1916)")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ch2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044075_Chapter_2"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "spacect"
  }, [_vm._v("Years of Study (1916–21)")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253044075_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "spacect"
  }, [_vm._v("Composer and Conductor (1921–29)")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253044075_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "spacect"
  }, [_vm._v("Leifs and the Elements of an Icelandic Style")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253044075_Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "spacect"
  }, [_vm._v("Icelandic Nation-Building and the 1930 Alþingi Festival (1929–33)")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253044075_Chapter_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "spacect"
  }, [_vm._v("“This Music Belongs to Us” (1933–37)")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253044075_Chapter_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7."), _c('span', {
    staticClass: "spacect"
  }, [_vm._v("Dinosaurs in Berlin (1937–44)")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ch8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253044075_Chapter_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8."), _c('span', {
    staticClass: "spacect"
  }, [_vm._v("Guilt and Retribution (1944–55)")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ch9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253044075_Chapter_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9."), _c('span', {
    staticClass: "spacect"
  }, [_vm._v("The Final Years (1955–68)")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf1",
    attrs: {
      "id": "pos"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253044075_Postlude",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Postlude: Revival and Influence")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "app"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253044075_Appendix",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Appendix: List of Jón Leifs’s Completed Works")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf0",
    attrs: {
      "id": "bib"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253044075_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Selected Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf0",
    attrs: {
      "id": "ind"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253044075_Index",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])]), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vi",
      "title": "vi"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-662b1248","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253044075_Contents.vue
// module id = 72
// module chunks = 0